function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M23.6082 4.89753C24.9607 4.89753 26.0571 3.8011 26.0571 2.44873C26.0571 1.09637 24.9606 0 23.6082 0C22.2554 0 21.1588 1.09643 21.1588 2.44873C21.1587 3.8011 22.2553 4.89753 23.6082 4.89753Z",
  fill: "#6F62FF"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M18.3013 2.08668H8.877C8.62936 2.08668 8.42861 1.88596 8.42861 1.63835C8.42861 1.39074 8.62936 1.19002 8.877 1.19002H18.3013C18.549 1.19002 18.7496 1.39074 18.7496 1.63835C18.7496 1.88596 18.549 2.08668 18.3013 2.08668Z",
  fill: "#6F62FF"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M9.87264 6.47015H0.448386C0.200744 6.47015 0 6.26943 0 6.02182C0 5.77421 0.200744 5.57356 0.448386 5.57356H9.87264C10.1203 5.57356 10.321 5.77421 10.321 6.02182C10.321 6.26943 10.1203 6.47015 9.87264 6.47015Z",
  fill: "#6F62FF"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M2.97835 11.0828C2.97835 11.3304 3.17909 11.5312 3.42674 11.5312H12.851C13.0986 11.5312 13.2994 11.3304 13.2994 11.0828C13.2994 10.8352 13.0986 10.6346 12.851 10.6346H3.42674C3.17909 10.6346 2.97835 10.8352 2.97835 11.0828Z",
  fill: "#6F62FF"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M22.321 5.18721C24.3473 6.39001 26.2304 6.16193 27.6367 4.19239C28.5548 2.90701 30.7004 4.13961 29.7718 5.43983C27.9776 7.95273 25.4584 8.90917 22.808 8.09723C21.9766 9.52541 21.1867 10.9787 20.4282 12.4478C21.5494 13.0209 22.8714 14.031 23.5523 14.5737C24.2295 15.1136 25.0591 16.925 25.6962 18.3161C25.8577 18.6687 26.0068 18.9943 26.1379 19.2653C26.8344 20.7046 24.5934 21.7485 23.8995 20.3153C23.7643 20.0361 23.6073 19.6915 23.4389 19.3221C22.8947 18.1283 22.2318 16.6741 21.8038 16.3217C21.243 15.8603 19.4026 14.5582 17.9986 14.0691C17.9295 14.0449 17.8665 14.0162 17.8069 13.9843C16.0883 16.1653 12.7218 17.1955 9.85066 15.5177C8.33776 14.6337 9.70621 12.454 11.2237 13.3408C13.3267 14.5705 15.5154 12.9982 16.5068 11.0293C17.4978 9.06049 18.2002 7.6747 19.0035 6.28045C17.4346 5.78009 16 6.23718 14.8718 7.81687C13.9543 9.10213 11.8083 7.86953 12.7362 6.56912C14.9197 3.51167 18.1757 2.75287 21.4355 4.68779C21.5037 4.72829 21.6924 4.83371 21.8807 4.9389C22.0667 5.04285 22.2524 5.14657 22.321 5.18721Z",
  fill: "#6F62FF"
});

var SvgFitness = function SvgFitness(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 30,
    height: 21,
    viewBox: "0 0 30 21",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFitness, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fitness.a687ea3b.svg";
export { ForwardRef as ReactComponent };